<h1 class="page-title">Data Exploration</h1>

<div class="main-content flex p-4">
  <div class="col-3">
    <form [formGroup]="form" (submit)="onSubmit()">

      <mat-form-field class="example-full-width">
        <input type="text" required="true" #autoTreeInput placeholder="{{getSelectedItems()}}" matInput (input)="filterChanged($event)" [matAutocomplete]="auto" />
        <mat-autocomplete (opened)="opened()" [panelWidth]="auto" #auto="matAutocomplete">
          <mat-option class="hidden" disabled></mat-option>
          <mat-tree [dataSource]="variablesCategories" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding (click)="todoLeafItemSelectionToggle(node)">
              <button mat-icon-button disabled></button>
              <!-- #23: label from `itemTitle` (display), selection check from `item` (technical key). -->
              <div class="checklist-leaf-node pointer">{{ node.itemTitle ? node.itemTitle : node.item }}
                <span></span>
                <mat-icon class="selected-column-icon" *ngIf="node.item===form.controls.column.value">check</mat-icon>
              </div>
            </mat-tree-node>

            <mat-tree-node class="node" *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
                <mat-icon class="mat-icon-rtl-mirror">{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
              </button>
              <div class="pointer">{{ node.item }}</div>
            </mat-tree-node>
          </mat-tree>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field [class.hidden]="form.controls.collectionName.value=='minibat'">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field [class.hidden]="form.controls.collectionName.value!=='minibat'">
        <mat-label>Choose a date</mat-label>
        <mat-select formControlName="minibatDate">
          <mat-option *ngFor="let item of minibatDates" [value]="item">{{ item }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Select Depth</mat-label>
        <input type="number" matInput min="0" formControlName="depth" step="1">
      </mat-form-field>

      <div class="flex justify-content-center mt-2">
        <button type="submit" mat-raised-button color="primary">Submit</button>
      </div>
    </form>

    <div *ngIf="closestDate" class="mt-4">Available Date: {{ closestDate | date: 'mediumDate' }}</div>
  </div>

  <div class="col-6 flex justify-content-center">
    <google-map [options]="mapOptions">
      <map-heatmap-layer [options]="heatmapOptions" [data]="heatmapData"></map-heatmap-layer>
    </google-map>
  </div>

  <div class="col-2 d-flex flex-column justify-content-between" *ngIf="heatmapData.length>0">
    <div>
      <div>Max Intensity: {{ this.maxIntensity }}</div>
      <mat-slider
        class="maxIntensity"
        [max]="200"
        [min]="1"
        [step]="1"
        [discrete]="false"
        [showTickMarks]="false">
        <input matSliderThumb [(ngModel)]="maxIntensity" #slider (ngModelChange)="setHeatMapOptions()">
      </mat-slider>

      <div>Radius: {{ this.radius }}</div>
      <mat-slider
        class="radius"
        [max]="50"
        [min]="1"
        [step]="1"
        [discrete]="false"
        [showTickMarks]="false">
        <input matSliderThumb [(ngModel)]="radius" #slider (ngModelChange)="setHeatMapOptions()">
      </mat-slider>

      <div>Opacity: {{ this.opacity }}</div>
      <mat-slider
        class="opacity"
        [max]="1"
        [min]="0"
        [step]="0.1"
        [discrete]="false"
        [showTickMarks]="false">
        <input matSliderThumb [(ngModel)]="opacity" #slider (ngModelChange)="setHeatMapOptions()">
      </mat-slider>
    </div>

    <div>
      <div class="color-bar">
        <div class="color-bar-item" *ngFor="let legend of colorLegend">
          <span class="color-box" [style.background-color]="legend.color"></span>
          <span class="value-range">{{ legend.range }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading-spinner *ngIf="loading"></app-loading-spinner>
